import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Loading from "../../components/Loading/Loading";
import TablePromotions from "./TablePromotions/TablePromotions";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";
import { getAllPromotionsAPI } from "../../services/Promotions/promotion";
import PromotionModal from "./ModalPromotion";
import AddIcon from "@mui/icons-material/Add";
import { setListPromotions } from "../../redux/slice/promotions";

const Promotions = () => {
  const [loading, setLoading] = useState(true);
  const [showModalPromotion, setShowModalPromotion] = useState(false);
  const { listPromotions } = useSelector((state) => state.promotionsReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    const getAllPromotions = async () => {
      try {
        setLoading(true);
        const responsePromotions = await getAllPromotionsAPI();
        // console.log("Promociones", responsePromotions);
        dispatch(
          setListPromotions({ listPromotions: responsePromotions ?? [] })
        );
        setLoading(false);
      } catch (error) {
        const { message } = handleError(error);
        dispatch(setListPromotions({ listPromotions: [] }));
        setLoading(false);
        // console.log("Error al traer las promociones:", error);
        toast.error(`No se pudieron obtner las promociones. \n ${message}`);
      }
    };
    getAllPromotions();
  }, [dispatch]);
  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <PromotionModal
        open={showModalPromotion}
        setOpen={setShowModalPromotion}
        setLoading={setLoading}
      />
      <Loading loading={loading} />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography variant="h5">Promociones</Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<AddIcon />}
          onClick={() => {
            setShowModalPromotion(true);
          }}
        >
          Agregar Promoción
        </Button>
      </Box>
      <TablePromotions setLoading={setLoading} rows={listPromotions ?? []} />
    </Box>
  );
};
export default Promotions;
